<template>
    <div id="capture">
        <div class="columns">
            <div class='column is-6 is-offset-3'>
                <p>&nbsp;</p>
                <form>
                    <div class='column is-horizontal-center top-logo'>
                          <figure class='image'>
                            <img src="../../assets/images/excel-logo-full.png">
                        </figure>
                    </div>

                    <div v-if="captureFailed">
                        <div class="password-reset" style="margin-bottom: 25px;">
                            <p style="margin-bottom: 10px;"><img src="../../assets/images/error.png"/></p>
                            <p style="font-size: 16px; font-weight: bold;">Save Failed</p>
                            <br/>
                            <p style="font-size: 16px;">
                                The server was unable to process your request. Please contact Excel for further assistance.
                            </p>
                        </div>
                    </div>

                    <div v-if="jobNotFound">
                        <div class="password-reset" style="margin-bottom: 25px;">
                            <p style="margin-bottom: 10px;"><img src="../../assets/images/error.png"/></p>
                            <p style="font-size: 16px; font-weight: bold;">Job Not Found</p>
                            <br/>
                            <p style="font-size: 16px;">
                                The server cannot locate this job, please use the link from email.
                            </p>
                        </div>
                    </div>

                    <div v-if="jobAvailable || captureSuccess">
                        <div v-if="jobAvailable" class="password-reset" style="margin-bottom: 25px;">
                            <p style="font-size: 16px;">
                                Friendly reminder on your upcoming appointment. Please confirm you’re still available. If you need to cancel, please call us immediately at: 800-915-0638 ext. 101.
                            </p>
                        </div>

                        <div v-if="captureSuccess" class="password-reset" style="margin-bottom: 25px;">
                            <div>
                                <p style="margin-bottom: 10px;"><img width="35px" height="35px" src="../../assets/images/success.png"/></p>
                                <p style="font-size: 16px; font-weight: bold;">You've accepted this assignment.</p>
                                <br/>
                                <p style="font-size: 16px;">
                                 If you need to cancel, please call us immediately at: 800-915-0638 ext. 101.
                                </p>
                            </div>
                        </div>
                        
                        <div v-if="formData[0].job_type_id === 2" class="password-reset" style="margin-bottom: 25px;">
                            <div class="details gray-bg">
                                <div class="field padded-bottom-border">
                                    <div class="control">
                                        <div class="columns">
                                            <div class="column is-6">
                                                <label>Date Due</label>
                                                <div class='formfield'>
                                                    {{formData[0].vendor_due_date}}
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <label>Time Due</label>
                                                <div class='formfield'>
                                                    {{formData[0].vendor_due_time}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="field padded-bottom">
                                    <div class="control">
                                        <div class="columns">
                                            <div class="column is-6">
                                                <label>Job</label>
                                                <div class='formfield'>
                                                    {{formData[0].job_no}}
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <label>Location</label>
                                                <div class='formfield' v-if="formData[0].job_type_id === 1">
                                                    {{formData[0].location_name}}
                                                </div>
                                                <div class='formfield' v-else>
                                                    {{ getJobType(formData[0].job_type_id) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="formData[0].job_type_id !== 2" class="password-reset" style="margin-bottom: 25px;">
                            <div class="details gray-bg">
                                <div class="field padded-bottom-border">
                                    <div class="control">
                                        <div class="columns">
                                            <div class="column is-6">
                                                <label>Service Date</label>
                                                <div class='formfield'>
                                                    {{formData[0].service_date}}
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <label>Service Time</label>
                                                <div class='formfield'>
                                                    {{formData[0].service_time}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="field padded-bottom">
                                    <div class="control">
                                        <div class="columns">
                                            <div class="column is-6">
                                                <label>Job</label>
                                                <div class='formfield'>
                                                    {{formData[0].job_no}}
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <label>Location</label>
                                                <div class='formfield' v-if="formData[0].job_type_id === 1">
                                                    {{formData[0].location_name}}
                                                </div>
                                                <div class='formfield' v-else>
                                                    {{ getJobType(formData[0].job_type_id) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </form>
            </div>
        </div>

    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    data () {
        return {
            token: '',
        }
    },
    
    computed: {
        ...mapState('vendorPoConfirm', {
            isLoading: state => state.isLoading,
            showTokenExpiredMessage: state => state.showTokenExpiredMessage,
        }),

        ...mapGetters('vendorPoConfirm', {
            jobNotAvailable: 'checkJobNotAvailable',
            jobNotFound: 'checkJobNotFound',
            jobAvailable: 'checkJobAvailable',
            captureSuccess: 'checkCaptureSuccess',
            captureFailed: 'checkCaptureFailed',
            formData: 'getFormData',
        })
    },

    methods: {
        getJobType: function(value){
            switch(value){
                case 2:
                    return "Translation";
                    break;
                case 3:
                    return "Telephonic";
                    break;
                case 4:
                    return "VRI";
                    break;
            }
        },

        // submit(val){
        //     VueStore.dispatch('vendorPoConfirm/saveData', val);
        // },

        returnToLogin(){
            window.location.href = '/login';
        },

        fetchData(){
            // this will save the url of client
            //VueStore.dispatch('global/getBaseURL');
        },

        prcoessURL(){
            var url_string = window.location.href;
            var url = new URL(url_string);
            var token = url.searchParams.get("token");
            var id = url.searchParams.get("id");
            var po_confirm_type_id = url.searchParams.get("po_confirm_type_id");

            if(po_confirm_type_id !== null){
                VueStore.dispatch('vendorPoConfirm/setVariable', {key: 'po_confirm_type_id', value: po_confirm_type_id}); 
            }

            if(token !== null && id !== null && po_confirm_type_id !== null){
                var data = {
                    token: token,
                    id: id,
                    po_confirm_type_id: po_confirm_type_id
                }
                
                // we'll save token for later usage 
                this.token = token;

                // delay so auth store is loaded.
                setTimeout(function(){ 
                    VueStore.dispatch('vendorPoConfirm/checkToken', data).then( (response) => {
                        if(typeof(response.data.status) !== 'undefined' && response.data.status !== '400'){
                            VueStore.dispatch('vendorPoConfirm/saveData').then( (response) => {
                            })
                        } 
                    })
                }, 500);
            } else {
                // show job not available
                VueStore.dispatch('vendorPoConfirm/setVariable', {key: 'jobNotFound', value: true}); 
            }
        }
    },

    mounted(){
        //this.fetchData();
        this.prcoessURL();
        // retrive environment variables and stored in vuex.
        VueStore.dispatch('auth/setVariables');
    }
}
</script>

<style>
body{
    overflow-y: auto;
    position: relative;
}

.center-button{
    display: flex;
    justify-content: center;
}
</style>